/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { QueryClient, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import fetch from '../../client.ts';
import { getListUserObjectsQueryResponseSchema } from '../schemas/getListUserObjectsSchema.ts';
import type { GetListUserObjects505, GetListUserObjectsQueryResponse } from '../types/GetListUserObjects.ts';

export const getListUserObjectsSuspenseQueryKey = () => ['USER_BACKEND', { url: '/list_user_objects' }] as const;

export type GetListUserObjectsSuspenseQueryKey = ReturnType<typeof getListUserObjectsSuspenseQueryKey>;

/**
 * {@link /list_user_objects}
 */
export async function getListUserObjectsSuspense(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetListUserObjectsQueryResponse, ResponseErrorConfig<GetListUserObjects505>, unknown>({
    method: 'GET',
    url: `/list_user_objects`,
    ...requestConfig,
  });
  return getListUserObjectsQueryResponseSchema.parse(res.data);
}

export function getListUserObjectsSuspenseQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getListUserObjectsSuspenseQueryKey();
  return queryOptions<
    GetListUserObjectsQueryResponse,
    ResponseErrorConfig<GetListUserObjects505>,
    GetListUserObjectsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getListUserObjectsSuspense(config);
    },
  });
}

/**
 * {@link /list_user_objects}
 */
export function useGetListUserObjectsSuspense<
  TData = GetListUserObjectsQueryResponse,
  TQueryKey extends QueryKey = GetListUserObjectsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<
        GetListUserObjectsQueryResponse,
        ResponseErrorConfig<GetListUserObjects505>,
        TData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getListUserObjectsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getListUserObjectsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetListUserObjects505>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
